export const getChatInfo = (pChat) => {
    if (!pChat) {
        return '';
    }

    if (pChat.type === 'group') {
        if (pChat.members != null) {
            return `${pChat.members} members`;
        }

        return '';
    }

    if (pChat.sub_title_) {
        return pChat.sub_title_;
    }

    if (pChat.description) {
        return pChat.description;
    }

    return '';
};

export const getAvatarLabel = (pChat) => {
    if (!pChat) {
        return '?';
    }

    if (pChat.type === 'group') {
        return 'G';
    }

    const lName = getChatDisplayName(pChat);
    if (!lName) {
        return '?';
    }

    return lName.charAt(0);
};

export const getBadgeValue = (pUnread) => {
    return pUnread > 99 ? '99+' : pUnread;
};

export const shouldShowBadge = (pUnread) => {
    return pUnread > 0 ? {} : { display: 'none' };
};

export const getChatDisplayName = (pChat) => {
    return pChat?.label_ || '';
};

export const formatTime = (pTimestamp) => {
    if (!pTimestamp) {
        return '';
    }

    // If already formatted string
    if (typeof pTimestamp === 'string') {
        return pTimestamp;
    }

    // Assume Date object
    return pTimestamp.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit'
    });
};